var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iac_wrap"},[_c('div',{staticClass:"item_add_title"},[_vm._v(_vm._s(_vm.$t('add_item')))]),_c('div',{staticClass:"item_add_sub"},[_vm._v(_vm._s(_vm.$t('add_item_collection')))]),_c('gallery-write-component',{attrs:{"galleryType":'galleryItemAdd',"galleryKey":_vm.galleryKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }